export default __webpack_public_path__ + "static/media/business-license-deactive.94614018.svg";